import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataLoadScoringAsync, dataLoadBadgesAsync } from '../utils/dataApi';

export const fetchScoringData = createAsyncThunk('scoring/fetchData', async () => {
  const data = await dataLoadScoringAsync();
  return data;
});

export const fetchBadgesData = createAsyncThunk('scoring/fetchBadges', async () => {
  const data = await dataLoadBadgesAsync();
  return data;
});

const scoringSlice = createSlice({
  name: 'scoring',
  initialState: {
    scoring: null,
    badges: null,
    scoringStatus: 'idle',
    badgesStatus: 'idle',
    scoringError: null,
    badgesError: null,
    scoringLoading: false,
    badgesLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScoringData.pending, (state) => {
        state.scoringStatus = 'loading';
        state.scoringLoading = true;
        state.scoringError = null;
      })
      .addCase(fetchScoringData.fulfilled, (state, action) => {
        state.scoringStatus = 'succeeded';
        state.scoring = action.payload;
        state.scoringLoading = false;
        state.scoringError = null;
      })
      .addCase(fetchScoringData.rejected, (state, action) => {
        state.scoringStatus = 'failed';
        state.scoringError = action.error.message;
        state.scoringLoading = false;
      })
      .addCase(fetchBadgesData.pending, (state) => {
        state.badgesStatus = 'loading';
        state.badgesLoading = true;
        state.badgesError = null;
      })
      .addCase(fetchBadgesData.fulfilled, (state, action) => {
        state.badgesStatus = 'succeeded';
        state.badges = action.payload;
        state.badgesLoading = false;
        state.badgesError = null;
      })
      .addCase(fetchBadgesData.rejected, (state, action) => {
        state.badgesStatus = 'failed';
        state.badgesError = action.error.message;
        state.badgesLoading = false;
      });
  },
});

export default scoringSlice.reducer;
